export default __webpack_public_path__ + "static/media/vitalii-tkachenko-lQ9lHXL73e8-unsplash.cff5e284.jpg";